import searchMap from '../assets/searchMap.svg';
import arrowRight from '../assets/arrowRight.svg';
import clearMap from '../assets/clearMap.svg';
import goodFace from '../assets/goodFace.svg';
import moderateFace from '../assets/moderateFace.svg';
import carelessFace from '../assets/carelessFace.svg';
import unhealthyFace from '../assets/unhealthyFace.svg';
import veryUnhealthyFace from '../assets/veryUnhealthyFace.svg';
import hazardousFace from '../assets/hazardousFace.svg';
import goodFaceBlack from '../assets/goodFaceBlack.svg';
import moderateFaceBlack from '../assets/moderateFaceBlack.svg';
import moderateFaceGray from '../assets/moderateFaceGray.svg';
import carelessFaceBlack from '../assets/carelessFaceBlack.svg';
import unhealthyFaceBlack from '../assets/unhealthyFaceBlack.svg';
import veryUnhealthyFaceBlack from '../assets/veryUnhealthyFaceBlack.svg';
import hazardousFaceBlack from '../assets/hazardousFaceBlack.svg';
import warningAlert from '../assets/warningAlert.svg';
import canarioAirLogo from '../assets/canarioAirLogo.svg';
import plusWhite from '../assets/plusWhite.svg';
import loginHeader from '../assets/login.svg';
import passEye from '../assets/passEye.svg';
import passEyeActive from '../assets/passEyeActive.svg';


export const iconsSmile = function (index, type = "") {
    let icon = undefined;
    switch (index) {
        case 0:
            icon = type === 'black' ? goodFaceBlack : goodFace;
            break;
        case "Green":
            icon = type === 'black' ? goodFaceBlack : goodFace;
            break;
        case 1:
            icon = type === 'black' ?
                moderateFaceBlack :
                type === 'gray' ?
                    moderateFaceGray :
                    moderateFace;
            break;
        case 2:
            icon = type === 'black' ? carelessFaceBlack : carelessFace;
            break;
        case "orange":
            icon = type === 'black' ? carelessFaceBlack : carelessFace;
            break;
        case 3:
            icon = type === 'black' ? unhealthyFaceBlack : unhealthyFace;
            break;
        case 4:
            icon = type === 'black' ? veryUnhealthyFaceBlack : veryUnhealthyFace;
            break;
        case "red":
            icon = type === 'black' ? veryUnhealthyFaceBlack : veryUnhealthyFace;
            break;
        case 5:
            icon = type === 'black' ? hazardousFaceBlack : hazardousFace;
            break;
    }
    return icon;
}

export {
    searchMap,
    arrowRight,
    clearMap,
    goodFace,
    moderateFace,
    carelessFace,
    unhealthyFace,
    veryUnhealthyFace,
    hazardousFace,
    goodFaceBlack,
    moderateFaceBlack,
    moderateFaceGray,
    carelessFaceBlack,
    unhealthyFaceBlack,
    veryUnhealthyFaceBlack,
    hazardousFaceBlack,
    warningAlert,
    canarioAirLogo,
    plusWhite,
    loginHeader,
    passEye,
    passEyeActive
};